<span>
  <mat-form-field
    appearance="fill"
    matAutocompleteOrigin
    #searchorigin="matAutocompleteOrigin"
    class="cw-search"
    >
    <input
      matInput
      id="app-nav-search"
      name="app-nav-search"
      placeholder="Search deals, funds, orgs, etc"
      [matAutocompleteConnectedTo]="searchorigin"
      [matAutocomplete]="searchauto"
      [formControl]="searchText"
      />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>

  <mat-autocomplete #searchauto="matAutocomplete" class="app-search-results">
    @if (storeSearchText.length > 0) {
      <span>
        @if (searchResults && !loading) {
          <span>
            @for (section of searchResults; track section) {
              <mat-optgroup
                [label]="section.keyname"
                >
                @for (val of section['data']; track val) {
                  <mat-option
            [ngClass]="{
              participants: val.participants && val.participants.length > 0
            }"
                    [value]="val.name"
            (click)="
                  section.keyname !== 'EIN Match'
                ? section.keyname !== 'Owned Entities' ? searchRedirect(section.keyname, val.id) : searchRedirect('Project', val.project.id)
                : searchRedirect(val.__typename, val.id)
            "
                    >
                    {{ val.name }}
                    @if (val.participants) {
                      <span>
                        <br />
                        @if (val.participants.length === 1) {
                          <span>
                            @if (val.participants[0].organization) {
                              <small
                                class="cw-search-details"
                                >{{ val.participants[0].organization.name }}</small
                                >
                              }
                              @if (val.participants[0].person) {
                                <small
                                  class="cw-search-details"
                                  >{{ val.participants[0].person.name }}</small
                                  >
                                }
                              </span>
                            }
                            @if (val.participants.length === 2) {
                              <span>
                                @if (val.participants[0].organization) {
                                  <small
                                    class="cw-search-details"
                                    >{{ val.participants[0].organization.name }}</small
                                    >
                                  }
                                  @if (val.participants[0].person) {
                                    <small
                                      class="cw-search-details"
                                      >{{ val.participants[0].person.name }}</small
                                      >
                                    }
                                    <small class="cw-search-details"> and </small>
                                    @if (val.participants[1].organization) {
                                      <small
                                        class="cw-search-details"
                                        >{{ val.participants[1].organization.name }}</small
                                        >
                                      }
                                      @if (val.participants[1].person) {
                                        <small
                                          class="cw-search-details"
                                          >{{ val.participants[1].person.name }}</small
                                          >
                                        }
                                      </span>
                                    }
                                    @if (val.participants.length > 2) {
                                      <span>
                                        @for (dev of val.participants; track dev; let isLast = $last) {
                                          <span>
                                            @if (isLast) {
                                              <small class="cw-search-details">and </small>
                                            }
                                            @if (dev.organization) {
                                              <small class="cw-search-details">{{
                                                dev.organization.name
                                              }}</small>
                                            }
                                            @if (dev.person) {
                                              <small class="cw-search-details">{{
                                                dev.person.name
                                              }}</small>
                                            }
                                            @if (!isLast) {
                                              <small class="cw-search-details">, </small>
                                            }
                                          </span>
                                        }
                                      </span>
                                    }
                                  </span>
                                }
                                @if (val.project) {
                                  <span>
                                    <br/>
                                    <small class="cw-search-details">{{val.project.name}}</small>
                                  </span>
                                }
                              </mat-option>
                            }
                            @if (
                              section['paginatorInfo'] &&
                              section['paginatorInfo']['currentPage'] <
                              section['paginatorInfo']['lastPage']
                              ) {
                              <mat-option
                                (click)="searchSubscription(this.storeSearchText, $event, true)"
                                >
                                <b>Load More</b>
                              </mat-option>
                            }
                          </mat-optgroup>
                        }
                      </span>
                    }
                    @if (!searchResults.length && storeSearchText.length > 1 && !loading) {
                      <mat-option
                        >
                        No matching results.
                      </mat-option>
                    }
                    @if (loading) {
                      <mat-option>
                        <span class="cw-search-load"
                          ><mat-spinner [diameter]="15"></mat-spinner>Loading...</span
                          >
                        </mat-option>
                      }
                    </span>
                  }
                </mat-autocomplete>

                <button mat-button disabled class="search-option-buttons">
                  <mat-label class="search-label">{{ searchSelect.value }}</mat-label>
                </button>

                <button
                  mat-icon-button
                  [matMenuTriggerFor]="searchTypeSelect"
                  class="filter-button-style"
                  >
                  <mat-icon
                    aria-hidden="false"
                    aria-label="Search Type Select"
                    class="filter-icon"
                    >filter_alt</mat-icon
                    >
                    <!--    <mat-icon aria-hidden="false" aria-label="Search Type Select" class="dropdown-icon"-->
                  <!--    >arrow_drop_down_icon</mat-icon-->
                  <!--    >-->
                </button>
                <mat-menu #searchTypeSelect="matMenu" xPosition="after">
                  @for (type of searchType; track type) {
                    <button
                      mat-menu-item
                      (click)="changeSearchType(type)"
                      >
                      {{ type }}
                    </button>
                  }
                </mat-menu>
              </span>
